import { colors } from 'modules/app/styles'
import { Input, Button, Label, Form } from 'reactstrap'
import styled from 'styled-components'
import ExpandedOn from 'assets/images/icons/expander_on.svg'

export const LoginBox = styled.div`
  height: 100vh;
  position: relative;
  display: flex;
  overflow: auto;
  justify-content: center;
  @media (max-width: 576px) {
    height: auto;
    overflow: unset;
  }
`

export const LoginForm = styled(Form)`
  margin-top: 20px;
  margin-bottom: 10px;
  width: 90%;
  &.add-members {
    width: 100%;
  }
  @media (min-width: 576px) {
    margin-top: 20px;
    width: 400px !important;
  }

  .form-group {
    margin-bottom: 30px;
    .role_tooltip {
      cursor: pointer;
      z-index: 2;
      position: absolute;
      right: 30px;
    }
  }
  @media (min-width: 1300px) {
    margin-top: 30px;
  }
  @media (min-width: 1600px) {
    margin-top: 40px;
    .form-group {
      margin-bottom: 40px;
    }
  }
`
export const LoginInfo = styled.div`
  width: 100%;
  @media (min-width: 1200px) {
    max-width: 650px;
  }
  background: #fff;
  overflow: auto;
  padding: 16px;
  box-shadow: 0px 16px 32px rgba(9, 27, 71, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 768px) {
    padding-top: 80px;
  }
`

export const Logo = styled.div`
  text-align: center;
  img {
    width: auto;
  }
`
export const HeaderImage = styled.div`
  text-align: center;

  &.col-flex{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

      h3:not(.no-separator):after {
        bottom: -60px;
      }
  }

  @media (min-width: 1600px), (max-width: 576px) {
    margin-bottom: 40px;
  }
  img {
    width: 160px;
    @media (min-width: 992px) {
      width: 220px;
    }
    @media (min-width: 1300px) {
      width: 240px;
    }
    @media (min-width: 1600px) {
      width: 280px;
      &.register {
        width: 260px;
      }
    }
  }
  .login-title {
    width: 100%;
    position: relative;
    font-size: 18px;
    font-weight: 400;
    margin-top: -5px;
    line-height: 1.5;
    &:not(.no-separator):after {
      content: '';
      position: absolute;
      bottom: -20px;
      left: calc(50% - 20px);
      right: calc(50% - 20px);
      height: 2px;
      background: ${colors['blue-100']};
    }
    @media (min-width: 576px) {
      width: 400px;
    }
    @media (min-width: 992px) {
      font-size: 22px;
    }
    @media (min-width: 1600px) {
      font-size: 24px;
    }
    .small {
      font-size: 14px;
      line-height: 1.5;
    }
  }
`

export const Separator = styled.hr`
  width: 60px;
  border-top: 1px solid #ffb73a;
  margin: 30px 0;
`

export const LoginInput = styled(Input)`
  font-size: 1.3rem !important;
  z-index: 1;
  position: relative;
  background: transparent;
  &:focus {
    background: transparent;
  }
`

export const EyeIcon = styled.a`
  position: absolute;
  top: 20px;
  right: 0;
  cursor: pointer;
  z-index: 1;
  color: ${colors['text-secondary']};
  &:hover {
    color: ${colors['text-secondary']};
  }
`

export const ForgotPassword = styled.a`
  position: absolute;
  top: 50px;
  right: 0;
  cursor: pointer;
  font-size: 85%;
  color: ${colors['text-secondary']};
  &:hover {
    color: ${colors['text-secondary']};
  }
  @media (min-width: 1600px) {
    top: 60px;
  }
`

export const LoginRegisterLinks = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  padding: 15px;
  background: #fff;
  @media (min-width: 576px) {
    top: 15px;
    padding: 0;
    background: none;
    right: 15px;
  }
  font-size: 14px;
  a {
    margin-left: 5px;
    background: ${colors['light-blue-100']};
    border: 1px solid ${colors['light-blue-300']};
    border-radius: 20px;
    padding: 4px 16px;
    font-weight: 600;
  }
`

export const CustomButton = styled(Button)`
  border: none;
  padding: 4px 16px;
  letter-spacing: 0.5px;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  font-family: 'Raleway';
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 40px;
  transition: 0s;
  box-shadow: 0px 4px 8px ${colors['main-text']}33;
  background: transparent;
  color: ${colors['main-text']};
  border: 1px solid ${colors['main-text']};
  &:hover,
  &:focus {
    box-shadow: 0px 4px 8px ${colors['main-text']}33;
    background: ${colors['blue-secondary']};
    color: ${colors['main-blue']};
    border: 1px solid ${colors['main-blue']};
  }

  &.btn-sm {
    font-weight: 600;
    padding: 3px 16px;
    font-size: 12px;
  }
  &.btn-lg {
    padding: 10px 15px;
    font-size: 16px;
  }

  // Colors
  &.black {
    &:not(.outlined) {
      background: ${colors['main-text']};
      color: #fff;
      &:not(:disabled):hover,
      &.active:not(:disabled) {
        border-color: ${colors['main-text']};
        background: ${colors['split-black']};
      }
    }
  }
  &.gray {
    &.outlined {
      border-color: ${colors['light-blue-300']};
      color: ${colors['main-text']};

      &:not(:disabled):hover,
      &:not(:disabled):focus,
      &.active:not(:disabled) {
        color: ${colors['main-text']};
        border-color: ${colors['light-blue-300']};
        background: ${colors['light-blue-200']};
      }
    }
    &:not(.outlined) {
      border-color: ${colors['light-blue-300']};
      background: ${colors['gray-200']};
      color: ${colors['main-text']};
      &:not(:disabled):hover,
      &:not(:disabled):focus,
      &.active:not(:disabled) {
        color: ${colors['main-text']};
        border-color: ${colors['light-blue-300']};
        background: ${colors['light-blue-200']};
      }
      &.hover-black:not(:disabled):hover {
        background: ${colors['main-text']};
        svg {
          stroke: #fff;
        }
        circle {
          fill: #fff;
        }
      }
    }
  }
  &.light-blue-100 {
    &.outlined {
      border-color: ${colors['blue-100']};
    }
    &:not(.outlined) {
      border-color: #c8d1e6;
      background: ${colors['light-blue-100']};
      color: ${colors['main-text']};
      &:not(:disabled):hover,
      &.active:not(:disabled) {
        background: ${colors['light-blue-200']};
      }
      &.hover-black:not(:disabled):hover {
        background: ${colors['main-text']};
        svg {
          stroke: #fff;
        }
        circle {
          fill: #fff;
        }
      }
    }
  }
  &.green {
    &:not(.outlined) {
      border-color: ${colors['green']};
      background: ${colors['green']};
      color: #fff;
    }
  }
  &.blue {
    &:not(.outlined) {
      border-color: ${colors['main-blue']};
      background: ${colors['main-blue']};
      color: #fff;
    }
    &.outlined {
      background: ${colors['blue-secondary']};
      color: ${colors['main-blue']};
      border: 1px solid ${colors['main-blue']};
      &:hover {
        background: ${colors['main-blue']};
        color: #fff;
      }
    }
  }
  &.red {
    &:not(.outlined) {
      border-color: ${colors['danger']};
      background: ${colors['danger']};
      color: #fff;
      &:not(:disabled):hover,
      &:not(:disabled):focus,
      &.active:not(:disabled) {
        color: #fff;
        border-color: ${colors['red']};
        background: ${colors['red']};
      }
    }
  }

  // Shadows
  &.shadow {
    box-shadow: 0px 4px 8px rgba(24, 24, 24, 0.2) !important;
  }

  // SPINNER
  .spinner {
    margin-left: 10px;
    width: 21px;
    height: 21px;
    border-radius: 20px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.25s;
    svg {
      width: 17px;
      height: 17px;
    }

    .spin {
      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
  &:not(:disabled) .spinner {
    background: #ffffff47;
  }
  &:not(:disabled):hover {
    .spinner {
      transform: translate3d(7px, 0, 0);
    }
  }

  // dropdown-toggle
  & ~ .dropdown-toggle {
    border-radius: 40px;
    border: none;
    border-left: 1px solid rgb(255 255 255 / 40%);
    padding: 0 8px;
    z-index: 1;
    &:after {
      border: none;
      background: url('${ExpandedOn}') no-repeat center/contain;
      width: 20px;
      height: 20px;
      filter: invert(1);
      display: block;
    }
  }
  &.black ~ .dropdown-toggle {
    background: ${colors['main-text']};
    color: #fff;
    &:hover {
      background: ${colors['split-black']};
    }
  }
`
export const PlanOption = styled(Label)`
  cursor: pointer;
  margin-bottom: 0;
  input {
    display: none;
    & + .planinfo {
      display: block;
      font-size: 1.2rem;
      position: relative;
      padding: 10px 15px;
      border-radius: 5px;
      max-width: 240px;
      width: 100%;
      background: #ffffff;
      border: 1px solid #999;
      transition: 0.25s;
      text-transform: capitalize;
      h5 {
        font-weight: 600;
      }
      svg {
        display: none;
        width: 20px;
        height: 20px;
        margin-right: 8px;
        fill: #ffc555;
        position: absolute;
        right: 0;
        top: 10px;
      }
      &:hover {
        box-shadow: 0px 5px 10px -4px rgb(0 0 0 / 20%);
        transform: translateY(-1px);
      }
    }
    &:checked + .planinfo {
      svg {
        display: inline-block;
      }
    }
  }
`
export const RoleGuideInfoIcon = styled.div`
  font-size: 8rem;
  position: absolute;
  color: #181818;
  text-align: center;
  margin-bottom: 25px;
  left: 0;
  // transform: translateX(-50%);
  opacity: 0.1;
`
